import React, { memo, useMemo } from 'react';
import { Table, TableProps } from 'tea-component';
import { SortBy } from "tea-component/table/addons";
import { getColumns } from './utils/common';
import './index.scss';

const { autotip, scrollable, sortable } = Table.addons;

type HandleCardType = 'base_scenario' | 'conservative_scenario' | '';
interface SortsType extends SortBy {
  handleCard: HandleCardType, // 操作的哪个卡片，和后端接口参数对应
}
interface MergeableTableProps {
  cardType: HandleCardType,
  loading: boolean,
  data: IStudioOverallFinanceForecastCardResultItem,
  sorts: SortsType,
  setSorts: React.Dispatch<React.SetStateAction<SortsType>>,
  [keyName: string]: any;
}

function MergeableTable(props: MergeableTableProps) {
  const {
    cardType,
    setHandleCard,
    loading,
    data,
    sorts,
    setSorts,
  } = props;

  const records = useMemo(() => {
    if (!Array.isArray(data) || !data?.length) return [];

    const newRecords = [];
    for (let i = 0; i < data?.length; i ++) {
      const t = data?.[i];
      newRecords.push({
        'uniqueId': i + 1,
        'date': t?.date,
        'revenue': t?.revenue,
        'profit': t?.profit,
        'margin': t?.margin,
      });
    }

    return newRecords;
  }, [data]);

  // 表格使用到的插件
  const addons = [
    sortable({
      // key名称排序的时候对应后端的传参字段，首字母转换成大写
      columns: [
        'date',
        'revenue',
        'profit',
        'margin',
      ],
      value: sorts ? [sorts] : [],
      onChange: (value) => {
        setHandleCard?.(cardType);
        setSorts?.({
          ...(value?.[0] || {}),
          handleCard: cardType,
        });
      },
    }),
    scrollable({
      // maxHeight: 250,
      minHeight: 250,
    }),
    autotip({
      isLoading: loading,
      hideIcon: !loading,  //loading状态显示图标，其他情况不显示
      emptyText: (
        <span style={{color: '#444'}}>
          No data yet.
        </span>
      ),
      style:{
        height: 222,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxSizing: 'border-box',
        margin: '0 auto',
      },
    }),
  ];

  return (
    <section className="dbg-studio-overall-finance-year-forecast-scenario-card-body">
      <Table
        className="dbg-common-table dbg-studio-overall-finance-year-forecast-scenario-card-list-table sort-icon-color"
        // bordered="all"
        records={loading ? [] : records}
        recordKey="uniqueId"
        columns={getColumns() as TableProps['columns']}
        addons={addons}
      />
    </section>
  )
}

MergeableTable.defaultProps = {
  cardType: '',
  setHandleCard: null,
  loading: false,
  data: null,
  sorts: {
    by: '',
    order: 'desc',
    handleCard: '',
  },
  setSorts: null,
}

export default memo(MergeableTable);

